export const text = {
  changes: "Please Save Changes",
  updated: "Changes Up-To-Date",
  save: "Save",
  delete: "Delete",
};
